/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Form,
  FormGroup,
  ControlLabel,
  Col,
} from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import FormBlock from 'loracoms/FormBlock';
import ControlTips from 'loracoms/ControlTips';
import Select from 'loracoms/Select';
import RichLabel from 'loracoms/RichLabel';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import deviceActions from 'loraactions/device';
import chplanActions from 'loraactions/chplan';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  sendCmd: React.PropTypes.func.isRequired,
  sendState: React.PropTypes.object.isRequired,
  getChannelPlans: React.PropTypes.func.isRequired,
  channelPlansState: React.PropTypes.object.isRequired,
  getTxSize: React.PropTypes.func.isRequired,
  getMacLog: React.PropTypes.func.isRequired,
};

class UpdChPlanReq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: ErrorSet.createEmpty().add('FE_EMPTY', 'chplan'),
      channelPlansState: props.channelPlansState,
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.macview');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeChPlan = this.handleChangeChPlan.bind(this);
  }

  componentWillMount() {
    const { getChannelPlans } = this.props;
    getChannelPlans();
  }

  componentWillReceiveProps(nextProps) {
    const { sendState, channelPlansState } = nextProps;

    if (sendState !== this.props.sendState) {
      this.setState({ sendStatus: sendState.status });
      if (sendState.status === 'success') {
        const { deviceId, getTxSize, getMacLog } = this.props;
        getTxSize(deviceId);
        getMacLog(deviceId);
      } else if (sendState.status === 'failure') {
        const { errors } = this.state;
        this.setState({ errors: errors.add(sendState.error.code, 'submit') });
      }
      _.delay(() => {
        this.setState({ sendStatus: '' });
      }, 1500);
    }
    if (channelPlansState !== this.props.channelPlansState) {
      this.setState({ channelPlansState });
    }
  }

  handleChangeChPlan(chplan) {
    this.setState({ chplan });
    const { errors } = this.state;
    this.setState({ errors: errors.remove('chplan') });
  }

  handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    const { errors } = this.state;
    if (!errors.isEmpty()) {
      return;
    }

    const { deviceId, sendCmd } = this.props;
    const { chplan } = this.state;
    sendCmd(deviceId, { cpid: chplan });
  }

  render() {
    const {
      chplan = '',
      errors,
      submitted = false,
      sendStatus = '',
      channelPlansState,
    } = this.state;
    const {
      data: { list: chplans = [] } = {},
    } = channelPlansState;

    return (
      <Form horizontal onSubmit={this.handleSubmit}>
        <FormGroup validationState={submitted && errors.has('chplan') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">{this.intlMsg.msg('updchplanreq.chplan')}</ControlLabel>
          </Col>
          <Col md={6}>
            <Select
              options={chplans.map(cp => ({
                label: cp.name,
                value: cp.id,
                formatter: () => <span><RichLabel content={cp.band} /> {cp.name}</span>,
              }))}
              placeholder={this.intlMsg.msg('updchplanreq.chplan.placeholder')}
              value={chplan}
              onChange={this.handleChangeChPlan}
            />
            <ControlTips
              show={submitted && errors.has('chplan')}
              message={this.intlMsg.errorMsg(errors.get('chplan'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <RichButton
              status={sendStatus}
              states={[{
                status: 'default',
                label: this.intlMsg.msg('submit'),
                style: 'primary',
                type: 'submit',
              }, {
                status: 'success',
                label: this.intlMsg.msg('submit.success'),
                style: 'success',
                timer: () => this.setState({ sentStatus: '' }),
              }, {
                status: 'failure',
                label: this.intlMsg.msg('submit.failure'),
                style: 'danger',
                timer: () => this.setState({ sentStatus: '' }),
              }]}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <FormBlock
              show={errors.has('submit')}
              message={this.intlMsg.errorMsg(errors.get('submit'))}
              azStyle="danger"
              closeButton
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

UpdChPlanReq.propTypes = propTypes;

const mapStateToProps = state => ({
  sendState: state.device.sendUpdChPlanReq,
  channelPlansState: state.chplan.getChannelPlans,
});

const mapDispatchToProps = {
  sendCmd: deviceActions.sendUpdChPlanReq,
  getChannelPlans: chplanActions.getChannelPlans,
  getTxSize: deviceActions.getMacTxSize,
  getMacLog: deviceActions.getMacLog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(UpdChPlanReq));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/MacView/coms/UdpChPlanReq.jsx